import store from "../../app/store";
import { createAction } from "@reduxjs/toolkit";
import { securedFetch } from "../../auth/authService";
import { getSortAndFilterQueryString } from "../../view/urlService";
import { ACTION_PARAMETER_CHANGED } from "./ParametersPageReducer";
import { PARAMETER_API } from "../../vars";


export function listPageable(pageNumber, pageSize) {

    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);

    return securedFetch(`${PARAMETER_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_PARAMETER_CHANGED)({ parameters: data.page }));
        return { users: data.page, totalPages: data.total, totalRecords: data.records }
    });

}
